import { createAction, createSlice } from "@reduxjs/toolkit";
import { ResponseState, FetchResponsesPayload, FetchResponsesModelPayload, FetchResponsesPromptPayload } from "./types";

export const initialState: ResponseState = {
  loading: false,
  responses: [],
  responseModal: null,
};

const responsesSlice = createSlice({
  name: "responses",
  initialState,
  reducers: {
    setResponsesLoading: (state) => {
      state.loading = true;
    },
    fetchResponsesSuccess: (state, action) => {
      state.loading = false;
      state.responses = action.payload;
    },
    fetchResponsesFailure: (state) => {
      state.loading = false;
    },

    fetchResponsesPromptSuccess: (state, action) => {
      const prevResponses = state.responses;
      state.loading = false;
      state.responses = prevResponses.concat(action.payload);
    },

    fetchResponsesPromptFailure: (state) => {
      state.loading = false;
    },

    fetchResponsesModelSuccess: (state, action) => {
      const prevResponses = state.responses;
      state.loading = false;
      state.responses = prevResponses.concat(action.payload);
    },

    fetchResponsesModelFailure: (state) => {
      state.loading = false;
    },


    setResponseModal: (state, action) => {
      state.responseModal = action.payload;
    },
    clearResponseModal: (state) => {
      state.responseModal = null;
    },
  },
});


export const fetchResponses = createAction<FetchResponsesPayload>("responses/fetchResponses");
export const fetchResponsesPrompt = createAction<FetchResponsesPromptPayload>("responses/fetchResponsesPrompt");
export const fetchResponsesModel = createAction<FetchResponsesModelPayload>("responses/fetchResponsesModel");


export const {
  setResponseModal,
  clearResponseModal,
  fetchResponsesSuccess,
  fetchResponsesFailure,
  setResponsesLoading,
  fetchResponsesPromptSuccess,
  fetchResponsesPromptFailure,
  fetchResponsesModelSuccess,
  fetchResponsesModelFailure,
} = responsesSlice.actions;

export default responsesSlice.reducer;
